import ConditionalInput from '../ConditionalInput';
import { RenameContainerStyle, RenameListStyle } from './style';
import { FaPlus, FaRegTrashCan } from 'react-icons/fa6';
import ArrowRightIcon from '../../../../../../../assets/icons/arrow-line-right.svg?react';
import React, { useState } from 'react';
import { ActionIcon, Box, Button, Checkbox, Flex, rem } from '@mantine/core';

export const RenameColumns = ({
  onChangeInput,
  onChangeColumn,
  filterTypes,
  columns,
  onAddFilterType,
  onDeleteSelectedItems
}) => {
  const [selectedItemsIds, setSelectedItemsIds] = useState([]);

  const onDelete = id => {
    const newSelectedItemsIds = selectedItemsIds.filter(itemId => itemId !== id);

    onDeleteSelectedItems(id, newSelectedItemsIds);
    setSelectedItemsIds([]);
  };

  const onSelect = id => {
    const newSelectedItemsIds = [...selectedItemsIds, id];

    setSelectedItemsIds(
      selectedItemsIds.find(itemId => itemId === id)
        ? selectedItemsIds.filter(itemId => itemId !== id)
        : newSelectedItemsIds
    );
  };

  return (
    <div id="grid-table-rename-columns-root" className="">
      <Flex
        id="grid-table-rename-columns-header"
        w="100%"
        justify="flex-end"
        h={rem(40)}
        align="center"
      >
        {selectedItemsIds.length > 0 && (
          <Button
            id="grid-table-rename-columns-delete-selected"
            size="sm"
            variant="transparent"
            onClick={onDelete}
            c="red"
            leftSection={<FaRegTrashCan fontSize="12px" />}
          >
            Delete ({selectedItemsIds.length})
          </Button>
        )}
      </Flex>

      <Box
        id="grid-table-rename-columns-shell"
        style={{ borderBottom: '1px solid #E4E4E7' }}
        pb={rem(16)}
      >
        <div id="grid-table-rename-columns-content" className="filter_content">
          <RenameListStyle id="grid-table-rename-columns-list">
            {filterTypes?.map(filterType => (
              <RenameSection
                key={filterType?.id}
                sectionId={filterType?.id}
                columns={columns}
                oldColumn={filterType.column}
                newColumn={filterType.value.input}
                onSelect={() => onSelect(filterType.id)}
                errors={filterType.errors || []}
                isSelected={selectedItemsIds.includes(filterType.id)}
                onChangeNewName={val => onChangeInput(filterType.id, filterType.id, val)}
                onChangeOldColumn={val => onChangeColumn(filterType?.id, filterType?.id, val)}
              />
            ))}

            <div id="grid-table-rename-columns-actions" className="actions">
              <ActionIcon
                id="grid-table-rename-columns-add"
                size="sm"
                w={rem(32)}
                h={rem(16)}
                variant="outline"
                onClick={() => onAddFilterType(true)}
              >
                <FaPlus fontSize="12px" />
              </ActionIcon>
            </div>
          </RenameListStyle>
        </div>
      </Box>
    </div>
  );
};

const RenameSection = ({
  sectionId,
  columns,
  onChangeNewName,
  onChangeOldColumn,
  oldColumn,
  newColumn,
  onSelect,
  isSelected,
  errors
}) => {
  const rootId = sectionId ? `grid-table-rename-section-${sectionId}` : 'grid-table-rename-section';

  return (
    <RenameContainerStyle id={rootId}>
      <Checkbox
        id={`${rootId}-select`}
        size="xs"
        mb={rem(7)}
        checked={isSelected}
        onClick={onSelect}
      />

      <label id={`${rootId}-old-label`}>
        <span>
          Current Column Name<span className="required">*</span>
        </span>

        <ConditionalInput
          id={`${rootId}-old-input`}
          type="column"
          columns={[...columns].filter(el => el)}
          value={oldColumn}
          hasRequiredError={errors.includes('column')}
          onChangeValue={onChangeOldColumn}
          hiddenVariants={['null', 'column', 'input', 'ai_input']}
        />
      </label>

      <span id={`${rootId}-arrow`} className="arrow">
        <ArrowRightIcon />
      </span>

      <label id={`${rootId}-new-label`}>
        <span>
          New Column Name<span className="required">*</span>
        </span>
        <ConditionalInput
          id={`${rootId}-new-input`}
          type="input"
          value={newColumn}
          hasRequiredError={errors.includes('value')}
          onChangeValue={onChangeNewName}
          hiddenVariants={['null', 'column', 'input', 'ai_input']}
        />
      </label>
    </RenameContainerStyle>
  );
};
